import { dateFormate } from "@constants/index";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const FormatDateView = (dbDateValue: any) => {
  return dayjs(dbDateValue).format(dateFormate.dd_mm_yyyy);
};

const DOB_TZ = "Asia/Kolkata";

// Parses a DOB coming from API / form into a Dayjs at start-of-day in IST.
export const parseDobToIstDayjs = (dob: any) => {
  if (!dob) return null;

  // ISO with timezone (Z / +hh:mm)
  if (typeof dob === "string" && /[zZ]|[-+]\d{2}:\d{2}$/.test(dob)) {
    const d = dayjs(dob).tz(DOB_TZ);
    return d.isValid() ? d.startOf("day") : null;
  }

  // "YYYY-MM-DD"
  if (typeof dob === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dob)) {
    const d = dayjs.tz(dob, "YYYY-MM-DD", DOB_TZ);
    return d.isValid() ? d.startOf("day") : null;
  }

  // timestamp/other string
  if (typeof dob === "string") {
    const d = dayjs(dob);
    return d.isValid() ? d.startOf("day") : null;
  }

  // Date/Dayjs object
  const d = dayjs(dob);
  return d.isValid() ? d.tz(DOB_TZ).startOf("day") : null;
};

//Formats DOB for API as YYYY-MM-DD (IST).
export const formatDobForApi = (dobValue: any, fallbackDob: any): string | null => {
  if (dobValue && dayjs(dobValue).isValid()) {
    return dayjs(dobValue).tz(DOB_TZ).format("YYYY-MM-DD");
  }
  const parsed = parseDobToIstDayjs(fallbackDob);
  return parsed ? parsed.format("YYYY-MM-DD") : null;
};